function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "iconfinder_Location_2_753940",
  d: "M18.464,6a5.765,5.765,0,0,0-5.5-6A5.749,5.749,0,0,0,7.472,5.867H7.466c0,.029,0,.059,0,.089s0,.033,0,.049c0,.06.007.117.008.176.062,3.9,4.1,8.011,5.491,9.475C16.869,12.2,18.006,9,18.334,7.291c.012-.06.022-.12.033-.18.032-.184.054-.349.069-.49,0,0,0,0,0-.005A4.185,4.185,0,0,0,18.464,6Z",
  transform: "translate(-7.466 -0.005)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 11,
    height: 15.649,
    viewBox: "0 0 11 15.649"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/location.4b32950e.svg";
export { SvgComponent as ReactComponent };